var App = App || {};

App.WidgetSwipe = (function ($) {
    'use strict';

    function Init(selector) {
        selector.each(function () {
            Swipe($(this));
        });
    }

    function Swipe(widget) {

        const speed = 250;
        const controls = widget.find(".widget-swipe-controls button");
        const mask = widget.find(".widget-swipe-mask");
        const scroll = widget.find(".widget-swipe-scroll");
        const content = widget.find(".widget-swipe-content");
        const focus = widget.find(".widget-swipe-content *");

        if (content.width() > scroll.width() ) {
            widget.addClass("mask-fwd");
        }

        // help if content element is focused on while outside of view
        focus.on("focus", function () {
            if ($(this).position().left + $(this).outerWidth() > mask.width() - 50) {
                scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $(this).outerWidth() - mask.width() + scroll.scrollLeft()
                }, speed * 2);
            }
        });

        controls.on("click", function () {

            const distance = (() => {
                switch ($(this).attr("data-swipe")) {
                    case "fwd":
                        return scroll.scrollLeft() + scroll.width() - 100;
                    case "back":
                        return scroll.scrollLeft() - scroll.width();
                    default:
                        return 0;
                }
            })();

            scroll.stop().animate({
                scrollLeft: distance
            }, speed * 2);
        });

        scroll.on("scroll", function () {
            Controls(widget, scroll, content, controls, speed);
        });

        $(window).on("resize", function () {
            Controls(widget, scroll, content, controls, speed);
        });
    }

    function Controls(widget, scroll, content, controls, speed) {

        if (scroll.scrollLeft() <= 10) {
            widget.removeClass("mask-back");
        }
        else {
            widget.addClass("mask-back");
        }
        if (scroll.scrollLeft() >= content.width() - scroll.width() - 10) {
            widget.removeClass("mask-fwd");
        }
        else {
            widget.addClass("mask-fwd");
        }
    }

    return {
        Init: Init
    };

})(jQuery);